import {doPost, doGet} from './Base';


const setTimezone = async (tz) => {
  let params = {'timezone': tz};
  return await doPost('/account/timezone', params);
};

const getTimezones = async () => {
  let resp = await doGet('/timezones');
  return resp.timezones;
};


export {getTimezones, setTimezone};
export default setTimezone;
